import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import './menu.styles.scss';

type MenuProps = {
  quickLinks: {
    title: string;
    to: string;
    active?: boolean;
  }[];
};

const Menu: React.FC<MenuProps> = ({ quickLinks }) => {
  return (
    <aside className="widget">
      <div className="widget widget_insight">
        <ul>
          {quickLinks.map(({ title, to, active }, i) => (
            <li key={i}>
              <Link {...{ to }} className={classnames({ active })}>
                {title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default Menu;
